import StatusTags from "@/components/StatusTags/StatusTags";
import { GetData } from "@/utilities/api";
import { ArrowRightOutlined, LoadingOutlined } from "@ant-design/icons";
import { UseQueryResult } from "@tanstack/react-query";
import { Button, Card, Col, Row, Space, Spin, Tooltip, Typography } from "antd";
import { Link } from "react-router-dom";
import "./Stats.scss";

const { Title, Text } = Typography;

type StatsStatus =
  | "no_data"
  | "complete"
  | "incomplete"
  | "has_issues"
  | "loading"
  | "calculating"
  | "error"
  | "not_available"
  | "disabled";

function getStatus(result: GetData | undefined): StatsStatus {
  const hasIssues =
    (result?.incomplete_count || 0) > 0 ||
    (result?.calculating_count || 0) > 0 ||
    (result?.error_count || 0) > 0;
  const isComplete = !hasIssues && (result?.total_count || 0) > 0;

  if (result) {
    if (hasIssues) return "has_issues";
    else if (isComplete) return "complete";
    else return "no_data";
  }
  return "no_data";
}
export interface IStatsProps {
  name: string;
  description: string;
  to: string;
  query?: UseQueryResult<GetData, unknown>;
  notAvailableMessage?: string;
  disabled?: boolean;
}

function Stats({ name, description, query, disabled, notAvailableMessage, to }: IStatsProps) {
  const status = notAvailableMessage
    ? "not_available"
    : disabled
      ? "disabled"
      : query?.isLoading || query?.isFetching
        ? "loading"
        : getStatus(query?.data);

  return (
    <Card className={`stats-card ${status}`}>
      <Link to={to}>
        <Row
          align={"middle"}
          justify={"space-between"}
          gutter={[20, 10]}
          wrap={false}
        >
          <Col>
            <Space
              direction="vertical"
              size={0}
            >
              <Title
                style={{ margin: 0 }}
                level={4}
              >
                {name}
              </Title>
              <Text className="gray-7">{description}</Text>
            </Space>
          </Col>
          <Col style={{ display: "flex", justifyContent: "flex-end" }}>
            {status === "loading" ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{
                      fontSize: 24,
                    }}
                    spin
                  />
                }
              />
            ) : status === "not_available" ? (
              <Tooltip title={notAvailableMessage}>
                <Button
                  disabled={true}
                  size={"small"}
                >
                  Not available yet
                </Button>
              </Tooltip>
            ) : status === "no_data" ? (
              <Button
                type={"primary"}
                size={"small"}
              >
                Start
              </Button>
            ) : status === "disabled" ? (
              <Button
                disabled={true}
                size={"small"}
              >
                Coming Soon
              </Button>
            ) : (
              <ArrowRightOutlined style={{ color: "#1890FF" }} />
            )}
          </Col>
        </Row>
        <Row
          justify={"space-between"}
          style={{ marginTop: 6 }}
        >
          <Col flex={1}>
            <Row justify={"space-between"}>
              <Col>
                <StatusTags
                  hideTotal={true}
                  loading={query?.isLoading || query?.isFetching}
                  data={query?.data}
                  background="white"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Link>
    </Card>
  );
}

export default Stats;
